var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("el-date-picker", {
            attrs: {
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "picker-options": _vm.pickerOptions
            },
            on: {
              change: function($event) {
                return _vm.ceshi()
              }
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.data } },
        [
          _c("el-table-column", { attrs: { label: "人员", prop: "name" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "删除点", prop: "deletePoint", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "取消一点", prop: "cancelPoint", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "新增点", prop: "addPoint", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "删除范围", prop: "deleteboundary", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "新增范围", prop: "addboundary", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "删除一类", prop: "deletelei", sortable: "" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "取消一类", prop: "cancellei", sortable: "" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("筛选猩号空间数据统计")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d4ab5d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4ab5d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/finishTable.vue
// module id = null
// module chunks = 